function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { createClassNames } from "../core/utils.js";
import Highlighter from "./Highlighter.js";
var cx = createClassNames('Snippet');
var Snippet = function Snippet(props) {
  return /*#__PURE__*/React.createElement(Highlighter, _extends({}, props, {
    highlightProperty: "_snippetResult",
    cx: cx
  }));
};
export default Snippet;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-instantsearch-dom/dist/es/components/Snippet.js
// module id = 646
// module chunks = 1